export enum ClientBenchmarkColumnNames {
  DefaultBenchmark = "Benchmark (%)",
  BenchmarkIPS = "Benchmark IPS (%)",
  BenchmarkFM = "Benchmark FM (%)",
  ReturnTarget = "Return Target (%)",
}



// WEBPACK FOOTER //
// ./src/app/clients/models/clientBenchmarkConfig.ts